<div id="settings-third-party-credentials-management" class="container-fluid pb-3">

    <div class="row">

        <!-- LEFT COLUMN WITH THIRD PARTY CREDENTIALS LIST -->

        <div class="col-sm-12 col-md-4">
            <mat-card>
                <mat-card-content>

                    <action-list *ngIf="thirdPartyCredentialsList"
                                 [idPrefix]="idPrefix"
                                 [items]="thirdPartyCredentialsList"
                                 [selected]="selectedThirdPartyCredentials"
                                 [identifier]="'key'"
                                 (select)="selectThirdPartyCredential($event)">
                    </action-list>

                </mat-card-content>
            </mat-card>
        </div>


        <!-- RIGHT COLUMN WITH DETAIL -->

        <div class="col-sm-12 col-md-8">

            <mat-card>
                <mat-card-content>

                    <smp-credentials *ngIf="selectedCredentialsType"
                                     [idPrefix]="(idPrefix + 'selected.')"
                                     [credentialsType]="selectedCredentialsType"
                                     [emailProviders]="emailProviders">
                    </smp-credentials>

                </mat-card-content>
            </mat-card>

        </div>
    </div>
</div>
